import { getTokenFromLocalStorage, getAdminTokenFromLocalStorage } from '../utils/tokenUtils';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_VERSION = process.env.REACT_APP_API_VERSION;

const getAuthHeaders = (): Record<string, string> => {
    const token = getTokenFromLocalStorage();
    const headers: Record<string, string> = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export const apiClient = async <T>(url: string, options: RequestInit = {}): Promise<T> => {
    const response = await fetch(`${BASE_URL}/api/${API_VERSION}${url}`, {
        ...options,
        headers: {
            ...options.headers,
            ...getAuthHeaders(),
        },
    });

    if (!response.ok) {
        throw new Error('Ошибка при запросе к API');
    }

    const data = await response.json();
    return data;
};



const getAdminAuthHeaders = (): Record<string, string> => {
    const token = getAdminTokenFromLocalStorage();
    const headers: Record<string, string> = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export const apiAdminClient = async <T>(url: string, options: RequestInit = {}): Promise<T> => {
    const response = await fetch(`${BASE_URL}/api/${API_VERSION}${url}`, {
        ...options,
        headers: {
            ...options.headers,
            ...getAdminAuthHeaders(),
        },
    });

    if (!response.ok) {
        throw new Error('Ошибка при запросе к API');
    }

    const data = await response.json();
    return data;
};
